import React from 'react';
import type { CountryCode } from '../../config/countries';
import { pendingFor } from '../../config/products';

export interface DraftDataBadgeProps {
  country: CountryCode | null | undefined;
  product: 'activities' | 'odm';
  geoType: string | null | undefined;
}

/** A small "Draft data" label for a target whose backend fix is pending; nothing for any other target. */
const DraftDataBadge: React.FC<DraftDataBadgeProps> = ({ country, product, geoType }) => {
  const pending = pendingFor(country, product, geoType);
  if (!pending) return null;
  return (
    <span className="badge badge-warning badge-outline badge-sm" title={pending.reason}>
      Draft data
    </span>
  );
};

export default DraftDataBadge;
